export const classes = {
  wrapper:
    'text-grey-8 dark:text-mauve-1 text-sm whitespace-pre-wrap break-words',
  mentionsWrapper: 'leading-6',
  mention: 'bg-grey-3 dark:bg-white/10 px-2 py-0.5 rounded-lg mx-1',
};

export const styles = {
  wrapper: {
    '& p': {
      display: 'inline',
    },
    '& ol': {
      listStyleType: 'decimal',
      paddingLeft: '1rem',
    },
    '& ul': {
      listStyleType: 'disc',
      paddingLeft: '1rem',
    },
  },
};
